// Site Owner Affiliate Configuration
// All Identity IQ referrals use this offer code
export const SITE_OWNER_OFFER_CODE = '4312985V';

// Identity IQ affiliate link generator
export const getCreditMonitoringLink = () => {
  return `https://www.identityiq.com/sc-securepreferred.aspx?offercode=${SITE_OWNER_OFFER_CODE}`;
};

// For backwards compatibility
export const getCreditHeroScoreLink = getCreditMonitoringLink;

// Track affiliate click
export const trackAffiliateClick = async (api, userId = null) => {
  try {
    await api.post('/affiliate/track', { user_id: userId });
  } catch (error) {
    console.error('Failed to track affiliate click:', error);
  }
};
